const USERINFO = 'index/USERiNFO' as const;
const SET_USER_INFO = 'index/SET_USER_INFO' as const;
const DELETE_USER_INFO = 'index/DELETE_USER_INFO' as const;
// 이 리덕스 모듈에서 관리 할 상태의 타입을 선언합니다
export type UserState = {
  email?: string;
  name: string;
  referral: string | null;
  level: string;
};

export const getUserInfo = () => ({
  type: USERINFO,
});

export const setUserInfo = (state: UserState) => ({
  type: SET_USER_INFO,
  payload: state,
});

export const deleteUserInfo = () => ({
  type: DELETE_USER_INFO,
  payload: initialState,
});

type UserAction = ReturnType<typeof getUserInfo> | ReturnType<typeof setUserInfo> | ReturnType<typeof deleteUserInfo>;

// 초기상태를 선언합니다.
const initialState: UserState = {
  email: '',
  name: 'member',
  referral: null,
  level: '1',
};

// 리듀서를 작성합니다.
// 리듀서에서는 state 와 함수의 반환값이 일치하도록 작성하세요.
// 액션에서는 우리가 방금 만든 CounterAction 을 타입으로 설정합니다.
function user(state: UserState = initialState, action: UserAction): UserState {
  switch (action.type) {
    case USERINFO:
      return { ...state };
    case SET_USER_INFO:
      return { ...action.payload };
    case DELETE_USER_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default user;
